import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Space, Typography, message, Select, Spin, Tabs, Descriptions, Tag, Collapse } from 'antd';
import { MessageOutlined, EditOutlined, LoadingOutlined } from '@ant-design/icons';
import { useAuth } from '../../context/DBContext';
import { functions } from '../../firebase_setup';
import jsPDF from 'jspdf';
import ProfileForm from '../signupPage/ProfileForm';
const { Title } = Typography;
const { Search } = Input;
const { Option } = Select;

const LOCAL_AUTHORITIES = [
  'Aberdeen City Council',
  'Aberdeenshire Council',
  'Administration',
  'Adur District Council',
  'Allerdale Borough Council',
  'Amber Valley Borough Council',
  'Angus Council',
  'Antrim and Newtownabbey District Council',
  'Argyll & Bute Council',
  'Armagh Banbridge and Craigavon District Council',
  'Arun District Council',
  'Ashfield District Council',
  'Ashford Borough Council',
  'Aylesbury Vale District Council',
  'Babergh District Council',
  'Barnsley Metropolitan Borough Council',
  'Barrow-in-Furness Borough Council',
  'Basildon District Council',
  'Basingstoke and Deane Borough Council',
  'Bassetlaw District Council',
  'Bath and North East Somerset Council',
  'Bedford Borough Council',
  'Belfast City Council',
  'Birmingham City Council',
  'Blaby District Council',
  'Blackburn with Darwen Borough Council',
  'Blackpool Borough Council',
  'Blaenau Gwent County Borough Council',
  'Bolsover District Council',
  'Bolton Metropolitan Borough Council',
  'Boston Borough Council',
  'Bournemouth Borough Council',
  'Bournemouth, Christchurch and Poole',
  'Bracknell Forest Borough Council',
  'Braintree District Council',
  'Breckland District Council',
  'Brentwood Borough Council',
  'Bridgend County Borough Council',
  'Brighton and Hove Council',
  'Bristol City Council',
  'Broadland District Council',
  'Bromsgrove District Council',
  'Broxbourne Borough Council',
  'Broxtowe Borough Council',
  'Buckinghamshire',
  'Burnley Borough Council',
  'Bury Metropolitan Borough Council',
  'Caerphilly County Borough Council',
  'Calderdale Metropolitan Borough Council',
  'Cambridge City Council',
  'Cannock Chase District Council',
  'Canterbury City Council',
  'Cardiff County Council',
  'Carlisle City Council',
  'Carmarthenshire County Council',
  'Castle Point Borough Council',
  'Causeway Coast and Glens',
  'Central Bedfordshire',
  'Ceredigion County Council',
  'Charnwood Borough Council',
  'Chelmsford Borough Council',
  'Cheltenham Borough Council',
  'Cherwell District Council',
  'Cheshire East',
  'Cheshire West and Chester Council',
  'Chesterfield Borough Council',
  'Chichester District Council',
  'Chiltern District Council',
  'Chorley Borough Council',
  'Christchurch Borough Council',
  'City and County of Swansea',
  'City of Bradford',
  'City of Glasgow',
  'City of York Council',
  'Clackmannanshire Council',
  'Colchester Borough Council',
  'Comhairle nan Eilean Siar',
  'Conwy County Borough Council',
  'Copeland Borough Council',
  'Corby Borough Council',
  'Cornwall County Council',
  'Corporation of the City of London',
  'Cotswold District Council',
  'Coventry City Council',
  'Craven District Council',
  'Crawley Borough Council',
  'Dacorum Borough Council',
  'Darlington Borough Council',
  'Dartford Borough Council',
  'Daventry District Council',
  'Denbighshire County Council',
  'Derby City Council',
  'Derbyshire Dales District Council',
  'Derry City and Strabane District Council',
  'Doncaster Metropolitan Borough Council',
  'Dorset Council',
  'Dover District Council',
  'Dudley Metropolitan Borough Council',
  'Dumfries and Galloway Council',
  'Dundee City Council',
  'Durham',
  'East Ayrshire Council',
  'East Cambridgeshire District Council',
  'East Devon District Council',
  'East Dorset District Council',
  'East Dunbartonshire Council',
  'East Hampshire District Council',
  'East Hertfordshire District Council',
  'East Lindsey District Council',
  'East Lothian Council',
  'East Northamptonshire Council',
  'East Renfrewshire Council',
  'East Riding of Yorkshire',
  'East Staffordshire Borough Council',
  'East Suffolk Council',
  'Eastbourne Borough Council',
  'Eastleigh Borough Council',
  'Eden District Council',
  'Edinburgh City Council',
  'Elmbridge Borough Council',
  'Epping Forest District Council',
  'Epsom and Ewell Borough Council',
  'Erewash Borough Council',
  'Exeter City Council',
  'Falkirk Council',
  'Fareham Borough Council',
  'Fenland District Council',
  'Fermanagh and Omagh District Council',
  'Fife Council',
  'Flintshire County Council',
  'Folkestone & Hythe District Council',
  'Forest of Dean District Council',
  'Fylde Borough Council',
  'Gateshead Metropolitan Borough Council',
  'Gedling Borough Council',
  'Gloucester City Council',
  'Gosport Borough Council',
  'Gravesham Borough Council',
  'Great Yarmouth Borough Council',
  'Greater Manchester Authority',
  'Guildford Borough Council',
  'Gwynedd Council',
  'Halton Borough Council',
  'Hambleton District Council',
  'Harborough District Council',
  'Harlow District Council',
  'Harrogate Borough Council',
  'Hart District Council',
  'Hartlepool Borough Council',
  'Hastings Borough Council',
  'Havant Borough Council',
  'Herefordshire Council',
  'Hertsmere Borough Council',
  'High Peak Borough Council',
  'Highland Council',
  'Hinckley and Bosworth Borough Council',
  'Horsham District Council',
  'Huntingdonshire District Council',
  'Hyndburn Borough Council',
  'Inverclyde Council',
  'Ipswich Borough Council',
  'Isle of Anglesey County Council',
  'Isle of Wight Council',
  'Isles of Scilly - Council of the',
  'Kettering Borough Council',
  'Kings Lynn and West Norfolk Borough Council',
  'Kingston-upon-Hull City Council',
  'Kirklees Metropolitan Council',
  'Knowsley Metropolitan Borough Council',
  'Lancaster City Council',
  'Leeds City Council',
  'Leicester City Council',
  'Lewes District Council',
  'Lichfield District Council',
  'Lincoln City Council',
  'Lisburn City and Castlereagh District Council',
  'Liverpool City Council',
  'London Borough of Barking and Dagenham',
  'London Borough of Barnet',
  'London Borough of Bexley',
  'London Borough of Brent',
  'London Borough of Bromley Council',
  'London Borough of Camden',
  'London Borough of Croydon',
  'London Borough of Ealing',
  'London Borough of Enfield',
  'London Borough of Hackney',
  'London Borough of Hammersmith & Fulham',
  'London Borough of Haringey',
  'London Borough of Harrow',
  'London Borough of Havering',
  'London Borough of Hillingdon',
  'London Borough of Hounslow',
  'London Borough of Islington',
  'London Borough of Lambeth',
  'London Borough of Lewisham',
  'London Borough of Merton',
  'London Borough of Newham',
  'London Borough of Redbridge',
  'London Borough of Richmond',
  'London Borough of Southwark',
  'London Borough of Sutton',
  'London Borough of Tower Hamlets',
  'London Borough of Waltham Forest',
  'London Borough of Wandsworth',
  'London Borough of Westminster',
  'Luton Borough Council',
  'Maidstone Borough Council',
  'Maldon District Council',
  'Malvern Hills District Council',
  'Manchester City Council',
  'Mansfield District Council',
  'Medway Council',
  'Melton Borough Council',
  'Mendip District Council',
  'Merthyr Tydfil County Borough Council',
  'Mid and East Antrim District Council',
  'Mid Devon District Council',
  'Mid Suffolk District Council',
  'Mid Sussex District Council',
  'Mid Ulster District Council',
  'Middlesbrough Borough Council',
  'Midlothian Council',
  'Milton Keynes Borough Council',
  'Mole Valley District Council',
  'Monmouthshire Council',
  'Moray Council',
  'Neath Port Talbot County Borough Council',
  'New Forest District Council',
  'Newark and Sherwood District Council',
  'Newcastle City Council',
  'Newcastle-under-Lyme Borough Council',
  'Newport City Council',
  'Newry Mourne and Down District Council',
  'North Ayrshire Council',
  'North Devon District Council',
  'North Dorset District Council',
  'North Down and Ards District Council',
  'North East Derbyshire District Council',
  'North East Lincolnshire Council',
  'North Hertfordshire District Council',
  'North Kesteven District Council',
  'North Lanarkshire Council',
  'North Lincolnshire Council',
  'North Norfolk District Council',
  'North Somerset Council',
  'North Tyneside Council',
  'North Warwickshire Borough Council',
  'North West Leicestershire District Council',
  'Northampton Borough Council',
  'Northumberland Council',
  'Norwich City Council',
  'Nottingham City Council',
  'Nuneaton and Bedworth Borough Council',
  'Oadby and Wigston District Council',
  'Oldham Metropolitan Borough Council',
  'Orkney Islands Council',
  'Oxford City Council',
  'Pembrokeshire Council',
  'Pendle Borough Council',
  'Perth & Kinross Council',
  'Peterborough Council',
  'Plymouth City Council',
  'Poole Borough Council',
  'Portsmouth City Council',
  'Powys County Council',
  'Preston Borough Council',
  'Purbeck District Council',
  'Reading Borough Council',
  'Redcar and Cleveland Borough Council',
  'Redditch Borough Council',
  'Reigate and Banstead Borough Council',
  'Renfrewshire Council',
  'Rhondda-Cynon-Taff Council',
  'Ribble Valley Borough Council',
  'Richmondshire District Council',
  'Rochdale Metropolitan Borough Council',
  'Rochford District Council',
  'Rossendale Borough Council',
  'Rother District Council',
  'Rotherham Metropolitan Borough Council',
  'Royal Borough of Greenwich',
  'Royal Borough of Kensington & Chelsea',
  'Royal Borough of Kingston upon Thames',
  'Royal Borough of Windsor and Maidenhead',
  'Rugby Borough Council',
  'Runnymede Borough Council',
  'Rushcliffe Borough Council',
  'Rushmoor Borough Council',
  'Rutland County Council',
  'Ryedale District Council',
  'Salford Metropolitan Borough Council',
  'Sandwell Metropolitan Borough Council',
  'Scarborough Borough Council',
  'Scottish Borders Council',
  'Sedgemoor District Council',
  'Sefton Metropolitan Borough Council',
  'Selby District Council',
  'Sevenoaks District Council',
  'Sheffield City Council',
  'Shetland Islands Council',
  'Shropshire Council',
  'Slough Borough Council',
  'Solihull Metropolitan Borough Council',
  'Somerset West and Taunton Council',
  'South Ayrshire Council',
  'South Bucks District Council',
  'South Cambridgeshire District Council',
  'South Derbyshire District Council',
  'South Gloucestershire District Council',
  'South Hams District Council',
  'South Holland District Council',
  'South Kesteven District Council',
  'South Lakeland District Council',
  'South Lanarkshire Council',
  'South Norfolk District Council',
  'South Northamptonshire Council',
  'South Oxfordshire District Council',
  'South Ribble Borough Council',
  'South Somerset District Council',
  'South Staffordshire District Council',
  'South Tyneside Metropolitan Borough Council',
  'Southampton Council',
  'Southend Borough Council',
  'Spelthorne Borough Council',
  'St Albans City and District Council',
  'St Helens Metropolitan Borough Council',
  'Stafford Borough Council',
  'Staffordshire Moorlands District Council',
  'Stevenage Borough Council',
  'Stirling Council',
  'Stockport Metropolitan Borough Council',
  'Stockton-on-Tees Borough Council',
  'Stoke-on-Trent City Council',
  'Stratford on Avon District Council',
  'Stroud District Council',
  'Sunderland City Council',
  'Surrey Heath Borough Council',
  'Swale Borough Council',
  'Swindon Borough Council',
  'Tameside Metropolitan Borough Council',
  'Tamworth Borough Council',
  'Tandridge District Council',
  'Teignbridge District Council',
  'Telford and Wrekin Council',
  'Tendring District Council',
  'Test Valley Borough Council',
  'Tewkesbury Borough Council',
  'Thanet District Council',
  'Three Rivers District Council',
  'Thurrock Council',
  'Tonbridge and Malling Borough Council',
  'Torbay Borough Council',
  'Torfaen County Borough Council',
  'Torridge District Council',
  'Trafford Metropolitan Borough Council',
  'Tunbridge Wells Borough Council',
  'Uttlesford District Council',
  'Vale of Glamorgan Council',
  'Vale of White Horse District Council',
  'Wakefield Metropolitan District Council',
  'Walsall Metropolitan Borough Council',
  'Warrington Borough Council',
  'Warwick District Council',
  'Watford Borough Council',
  'Waverley Borough Council',
  'Wealden District Council',
  'Wellingborough Borough Council',
  'Welwyn Hatfield District Council',
  'West Berkshire Council',
  'West Devon Borough Council',
  'West Dorset District Council',
  'West Dunbartonshire Council',
  'West Lancashire Borough Council',
  'West Lindsey District Council',
  'West Lothian Council',
  'West Oxfordshire District Council',
  'West Suffolk Council',
  'Weymouth and Portland Borough Council',
  'Wigan Metropolitan Borough Council',
  'Wiltshire Council',
  'Winchester City Council',
  'Wirral Metropolitan Borough Council',
  'Woking Borough Council',
  'Wokingham Borough Council',
  'Wolverhampton City Council',
  'Worcester City Council',
  'Worthing Borough Council',
  'Wrexham County Borough Council',
  'Wychavon District Council',
  'Wycombe District Council',
  'Wyre Borough Council',
  'Wyre Forest District Council'
];

const ExpandedRowContent = ({ record }) => {
  const [bookings, setBookings] = useState([]);
  const [loadingBookings, setLoadingBookings] = useState(false);
  const { fetchAdminUserBookings, updateUser } = useAuth();
  const [isProfileEditVisible, setIsProfileEditVisible] = useState(false);
  const [editingProfile, setEditingProfile] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const loadBookings = async () => {
      setLoadingBookings(true);
      try {
        const fetchedBookings = await fetchAdminUserBookings(record.id);
        setBookings(fetchedBookings);
      } catch (error) {
        // console.error('Error loading bookings:', error);
        message.error('Failed to load bookings');
      } finally {
        setLoadingBookings(false);
      }
    };
    loadBookings();
  }, [record.id, fetchAdminUserBookings]);

  const handleProfileUpdate = async (editedProfile) => {
    setIsSaving(true);
    try {
      if (record.accountType === 'self') {
        await updateUser(record.id, { profile: editedProfile });
      } else {
        // For children account, update the specific child
        const updatedChildren = record._children.map(child => 
          child.id === editingProfile.id ? { ...child, ...editedProfile } : child
        );
        await updateUser(record.id, { children: updatedChildren });
      }
      message.success('Profile updated successfully');
      setIsProfileEditVisible(false);
    } catch (error) {
      // console.error('Error updating profile:', error);
      message.error('Failed to update profile');
    } finally {
      setIsSaving(false);
    }
  };

  const bookingColumns = [
    {
      title: 'Service Name',
      dataIndex: 'serviceName',
      key: 'serviceName'
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date'
    },
    {
      title: 'Time',
      key: 'time',
      render: (_, record) => `${record.startTime} - ${record.endTime}`
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'Confirmed' ? 'green' : 'orange'}>
          {status}
        </Tag>
      )
    }
  ];

  const ProfileDetails = ({ data, isSelf = false }) => (
    <Descriptions bordered column={2}>
      <Descriptions.Item label="Date of Birth">{data?.dateOfBirth}</Descriptions.Item>
      <Descriptions.Item label="Age Group">{data?.age}</Descriptions.Item>
      <Descriptions.Item label="Gender">{data?.gender}</Descriptions.Item>
      <Descriptions.Item label="Gender Other">{data?.genderOther}</Descriptions.Item>
      <Descriptions.Item label="Ethnicity">{data?.ethnicity}</Descriptions.Item>
      <Descriptions.Item label="Ethnicity Other">{data?.ethnicityOther}</Descriptions.Item>
      <Descriptions.Item label="Disability">{data?.disability}</Descriptions.Item>
      <Descriptions.Item label="Disability Other">{data?.disabilityOther}</Descriptions.Item>
      <Descriptions.Item label="Education Status">{data?.educationStatus}</Descriptions.Item>
      <Descriptions.Item label="Benefits">
        <Space direction="vertical">
          <Tag color={data?.dla === 'yes' ? 'green' : 'red'}>DLA: {data?.dla}</Tag>
          <Tag color={data?.pip === 'yes' ? 'green' : 'red'}>PIP: {data?.pip}</Tag>
          <Tag color={data?.ehcp === 'yes' ? 'green' : 'red'}>EHCP: {data?.ehcp}</Tag>
        </Space>
      </Descriptions.Item>
      <Descriptions.Item label="Interests">
        {data?.interests?.map(interest => (
          <Tag key={interest}>{interest}</Tag>
        ))}
      </Descriptions.Item>
    </Descriptions>
  );

  const content = record.accountType === 'self' ? (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <Title level={4}>Profile Details</Title>
      </div>
      <ProfileDetails data={record.profile} isSelf={true} />
      
      <Title level={4} style={{ marginTop: '24px' }}>Bookings</Title>
      <Table
        columns={bookingColumns}
        dataSource={bookings}
        rowKey="id"
        loading={loadingBookings}
        pagination={false}
      />
    </div>
  ) : (
    <Tabs type="card">
      {record._children?.map(child => (
        <Tabs.TabPane 
          tab={`${child.firstName} ${child.lastName}`} 
          key={child.id}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <Title level={4}>Profile Details</Title>
          </div>
          <ProfileDetails data={child} />
          
          <Title level={4} style={{ marginTop: '24px' }}>Bookings</Title>
          <Table
            columns={bookingColumns}
            dataSource={bookings.filter(booking => booking.childId === child.id)}
            rowKey="id"
            loading={loadingBookings}
            pagination={false}
          />
        </Tabs.TabPane>
      ))}
    </Tabs>
  );

  return (
    <>
      {content}
    </>
  );
};

const AdminUserManagement = () => {
 
  const {
    updateUser,
    fetchFamilyUsers,
    fetchLocalAuthorityUsers,
    sendMessage,
    currentUser,
    fetchUserReportData,
    fetchAdminUserBookings
  } = useAuth();  
  
  // State variables
  const [users, setUsers] = useState([]);
  const [authorities, setAuthorities] = useState([]);
  const [form] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loadingUsers, setLoadingUsers] = useState(true);

  useEffect(() => {
    async function loadUsers() {
      try {
        const fetchedUsers = await fetchFamilyUsers();
        const filteredUsersByAuthority = fetchedUsers.filter(user => user.localAuthorityId === currentUser.uid);
        setUsers(filteredUsersByAuthority);
        setFilteredUsers(filteredUsersByAuthority.slice(0, pageSize));
      } catch (error) {
        message.error("Failed to load users.");
      } finally {
        setLoadingUsers(false);
      }
    }
    loadUsers();
  }, [pageSize, currentUser.uid]);

  // Fetch local authorities
  useEffect(() => {
    const fetchAuthorities = async () => {
      try {
        const data = await fetchLocalAuthorityUsers();
        setAuthorities(data);
      } catch (error) {
        // console.error('Error fetching local authorities:', error);
      }
    };
    fetchAuthorities();
  }, [fetchLocalAuthorityUsers]);
  
  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
    const startIndex = (page - 1) * newPageSize;
    setFilteredUsers(users.slice(startIndex, startIndex + newPageSize));
  };

  // Columns for the user table
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: 'Account Type',
      dataIndex: 'accountType',
      key: 'accountType',
      filters: [
        { text: 'Self', value: 'self' },
        { text: 'Children', value: 'children' }
      ],
      onFilter: (value, record) => record.accountType === value
    },
    {
      title: 'LA Representative',
      dataIndex: 'localAuthorityId',
      key: 'localAuthorityId',
      render: (localAuthorityId) => {
        const authority = authorities.find(auth => auth.id === localAuthorityId);
        return authority ? `${authority.firstName} ${authority.lastName}` : 'None';
      }
    },
    {
      title: 'Local Authority',
      dataIndex: 'laRep',
      key: 'laRep'
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size="small">
          <Button icon={<MessageOutlined />} onClick={() => messageUser(record)}>
            Message
          </Button>
        </Space>
      )
    }
  ];

  const expandedRowRender = (record) => {
    return <ExpandedRowContent record={record} />;
  };

  // message
  const [isMessageModalVisible, setIsMessageModalVisible] = useState(false);
  const [messageContent, setMessageContent] = useState('');
  const [recipient, setRecipient] = useState(null); // Track recipient (null for all users)

  const messageUser = (user) => {
    setRecipient(user);  // Set recipient as the selected user
    setIsMessageModalVisible(true);
  };
  
  const messageAllUsers = () => {
    setRecipient(null);  // Null indicates the message is for all users
    setIsMessageModalVisible(true);
  };
  
  const handleSendMessage = async () => {
    setLoadingAction(true); // start loading

    if (recipient) {
      // Send a message to the individual user
      try {
        await sendMessage(currentUser.uid, recipient.name, recipient.id, messageContent);  // sendMessage internally ensures the conversation exists
        message.success(`Message sent to ${recipient.name}`);
      } catch (error) {
        message.error('Failed to send message to the user.');
        // console.error('Error sending message:', error);
      }
    } else {
      // Send a message to all users
      try {
        await Promise.all(
          users.map((user) =>
            sendMessage(currentUser.uid, user.name, user.id, messageContent)
          )
        );
        message.success('Message sent to all users.');
      } catch (error) {
        message.error('Failed to send message to all users.');
        // console.error('Error sending message:', error);
      }
    }
    setIsMessageModalVisible(false);  // Close modal after sending
    setLoadingAction(false); // Stop loading
  };
  
  // loading 
  const [loadingAction, setLoadingAction] = useState(false); // For actions like messaging, editing

  // State for search value
  const [searchValue, setSearchValue] = useState('');

  // State for filtered users
  const [filteredUsers, setFilteredUsers] = useState(users);

  // Update filteredUsers whenever users or searchValue changes
  useEffect(() => {
    const filtered = users.filter(user =>
      Object.keys(user).some(key =>
        String(user[key]).toLowerCase().includes(searchValue.toLowerCase())
      )
    );
    setFilteredUsers(filtered);
  }, [users, searchValue]);

  if (loadingUsers) {
    // Display a loading spinner while the page data is loading
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                      </div>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Title level={3}>User Management</Title>
      <Space style={{ marginBottom: 16 }}>
        {/* Search Bar */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            placeholder="Search users"
            onChange={(e) => setSearchValue(e.target.value)}
            style={{ height: '38px', lineHeight: '38px', width: '500px' }}
          />
        </div>
        <Button icon={<MessageOutlined />} onClick={messageAllUsers}>
          Message All Users
        </Button>
      </Space>

      <Table 
        columns={columns} 
        dataSource={filteredUsers.map(user => {
          const { children, ...userWithoutChildren } = user;
          return { ...userWithoutChildren, key: user.id, _children: children };
        })} 
        rowKey="key"
        expandable={{
          expandedRowRender,
          childrenColumnName: undefined,
          rowExpandable: record => true
        }}
        pagination={{
          position: ['bottomCenter'],
          current: currentPage,
          pageSize: pageSize,
          total: users.length,
          showSizeChanger: true, 
          pageSizeOptions: ['10', '30', '50', '100'], 
          onChange: handlePageChange,
        }} 
      />

      {/* Message modal */}
      <Modal
        title={recipient ? `Send Message to ${recipient.name}` : 'Send Message to All Users'}
        visible={isMessageModalVisible}
        onOk={handleSendMessage}
        onCancel={() => setIsMessageModalVisible(false)}
        okText="Send"
        confirmLoading={loadingAction}
      >
        <Form layout="vertical">
          <Form.Item label="Message">
            <Input.TextArea 
              rows={4} 
              value={messageContent}
              onChange={(e) => setMessageContent(e.target.value)} 
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AdminUserManagement;
